import { request } from '../request'

// 获取安全配置
export const getSecurityConfig = () => request('/portal/user/safe_setting')

// 修改安全配置
export const putSecurityConfig = data =>
  request('/portal/user/safe_setting', { method: 'PUT', data })
